// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.md-form .read-textarea:disabled {
  overflow: auto;
  resize: none;
  height: calc(100vh - 300px) !important;
  pointer-events: inherit !important;
}

.md-form textarea.form-control {
  min-height: 300px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/administration/instructions/instructions-modal/instructions-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,YAAA;EACA,sCAAA;EACA,kCAAA;AACJ;;AACA;EACI,4BAAA;AAEJ","sourcesContent":[".md-form .read-textarea:disabled {\r\n    overflow: auto;\r\n    resize: none;\r\n    height: calc(100vh - 300px) !important;\r\n    pointer-events: inherit !important;\r\n}\r\n.md-form textarea.form-control {\r\n    min-height: 300px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
